import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSartAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitSartAssessmentResultInput;
}>;


export type SubmitSartAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitSartAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitSartAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & SartAssessmentResultFragment
    )> }
  ) }
);

export type SartAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'BmpResult' } | { __typename: 'CardioRespResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'ML360Result' } | { __typename: 'March20kmResult' } | (
    { __typename: 'SartResult' }
    & SartAssessmentResultDataFragment
  ) | { __typename: 'SelfDeterminationResult' } | { __typename: 'SocResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } | { __typename: 'WeightResult' } }
);

export type SartAssessmentResultDataFragment = (
  { __typename: 'SartResult' }
  & Pick<SchemaTypes.SartResult, 'correctHits' | 'misses' | 'incorrectPresses' | 'averageResponseTimeMs' | 'fastestResponseTimeMs'>
  & { trials: Array<(
    { __typename: 'SartTrialResult' }
    & Pick<SchemaTypes.SartTrialResult, 'index' | 'stimulusDigit' | 'responseTimeMs' | 'isTriggerDigit' | 'isCorrect' | 'errorType'>
  )> }
);

export const SartAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SartAssessmentResultData on SartResult {
  trials {
    index
    stimulusDigit
    responseTimeMs
    isTriggerDigit
    isCorrect
    errorType
  }
  correctHits
  misses
  incorrectPresses
  averageResponseTimeMs
  fastestResponseTimeMs
}
    `;
export const SartAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment SartAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on SartResult {
      ...SartAssessmentResultData
    }
  }
  createdAt
}
    `;
export const SubmitSartAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitSartAssessmentResult($input: SubmitSartAssessmentResultInput!) {
  submitSartAssessmentResult(input: $input) {
    ... on SubmitSartAssessmentResultSuccessfulResponse {
      result {
        ...SartAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SartAssessmentResultFragmentDoc}
${SartAssessmentResultDataFragmentDoc}`;
export type SubmitSartAssessmentResultMutationFn = Apollo.MutationFunction<SubmitSartAssessmentResultMutation, SubmitSartAssessmentResultMutationVariables>;

/**
 * __useSubmitSartAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitSartAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSartAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSartAssessmentResultMutation, { data, loading, error }] = useSubmitSartAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSartAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSartAssessmentResultMutation, SubmitSartAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSartAssessmentResultMutation, SubmitSartAssessmentResultMutationVariables>(SubmitSartAssessmentResultDocument, options);
      }
export type SubmitSartAssessmentResultMutationHookResult = ReturnType<typeof useSubmitSartAssessmentResultMutation>;
export type SubmitSartAssessmentResultMutationResult = Apollo.MutationResult<SubmitSartAssessmentResultMutation>;
export type SubmitSartAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitSartAssessmentResultMutation, SubmitSartAssessmentResultMutationVariables>;